<template>
  <v-app id="inspire" :style="cssProps" :class="[{'css-settings-dark': $store.state.themeDark}, {'css-settings-light': !$store.state.themeDark}]">
    
    <v-app-bar
    app
    clipped-left
    flat
    style="box-shadow: 0 7px 14px 0 rgba(60, 66, 87, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07);"
    class="foreground"
    > 

      <v-app-bar-nav-icon @click.stop="clickMenu()"></v-app-bar-nav-icon>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
          icon
          v-on="on"
          @click="toggleTracerNav()"
          class="mr-2"
          >
            <v-icon>mdi-package-variant</v-icon>
          </v-btn>
        </template>
        <span>Open Inventory drawer</span>
      </v-tooltip>
      <v-toolbar-title>Corex</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
          icon
          v-on="on"
          to="/dashboard"
          class="mr-2"
          >
            <v-icon>mdi-view-dashboard-outline</v-icon>
          </v-btn>
        </template>
        <span>Dashboard</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
          icon
          v-on="on"
          @click="toggleTimelineNav()" 
          class="mr-2"
          >
            <v-icon small>mdi-timeline-text-outline</v-icon>
          </v-btn>
        </template>
        <span>Open timeline drawer</span>
      </v-tooltip>

      <v-btn icon class="mr-2" to="/notifications">
        <v-badge
          color="red"
          right
          top
          overlap
          >
          <template v-slot:badge>
            1
          </template>
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>

      <v-menu offset-y max-height="50vh" :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="mr-2">
            <v-avatar size="36px">
              <img src="@/assets/img/icons/pvlogo.png" alt="avatar">
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-menu max-height="50vh" max-width="350px" offset-x left :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" active-class="active-link">
                <v-list-item-avatar size="36">
                  <v-icon>brush</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>Theme</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </template>
            <div>
              <v-list>
                <v-list-item v-for="(item, index) in themes" :key="index" @click="setTheme(item)">
                  <v-icon v-if="item.title === 'Theme 1 - Dark'" class="mr-2">mdi-image-outline</v-icon>
                  <v-list-item-title :class="{'font-weight-bold color1--text': (item.value === $store.state.theme) && (item.dark === $store.state.themeDark)}">{{ item.title }}</v-list-item-title>
                </v-list-item>

                <!-- IMAGE AREA -->
                <template v-if="$store.state.themeDark">
                  <div class="c-hr"></div>
                  <div class="d-flex align-center pa-2 caption">
                    Random background image
                    <v-spacer></v-spacer>
                    <v-btn
                    icon
                    small
                    :disabled="$store.state.themeSavedImages.includes(cssImageUrl)"
                    @click="saveBackgroundImage">
                      <v-icon color="color1">mdi-cloud-upload-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="d-flex align-center pa-2">
                    <v-btn
                    icon
                    small
                    @click="randomImageIndex--">
                      <v-icon color="color1">mdi-minus</v-icon>
                    </v-btn>

                    <v-text-field
                    v-model="randomImageIndex"
                    hide-details
                    :class="['caption crx-box-input']"
                    solo
                    >
                    </v-text-field>

                    <v-btn
                    icon
                    small
                    @click="randomImageIndex++">
                      <v-icon color="color1">mdi-plus</v-icon>
                    </v-btn>
                  </div>

                  <div 
                  v-for="(img, index) of $store.state.themeSavedImages" 
                  :key="'img' + index" 
                  class="theme-img-block" 
                  :style="{'background-image': img}"
                  @click.stop="clickThemeImage(img)"
                  >
                    <v-btn icon small style="position: absolute; right: 0;" color="white"
                    @click.stop="clickDeleteThemeImage(img)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
                <!-- IMAGE AREA -->
               
              </v-list>
            </div>
          </v-menu>

          <v-list-item to="/user/profile" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>person_outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>{{ $store.state.auth.username }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="signOut()">
            <v-list-item-avatar size="36">
              <v-icon>exit_to_app</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Log out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


        </v-list>

      </v-menu>

    </v-app-bar>
  
    <!-- main nav drawer -->
    <nav-main ref="navMain"></nav-main>

    <search-console ref="searchConsole"></search-console>

    <tracer-nav ref="tracerNav"></tracer-nav>
    <timeline-nav ref="timelineNav"></timeline-nav>

    <v-content ref="content" v-scroll="onScroll" :class="['background', {'img-background': $store.state.theme === 'theme1' && $store.state.themeDark}]">

      <transition mode="out-in" :name="transitionName" @before-leave="beforeLeave" @after-leave="afterLeave" @after-enter="afterEnter">
        <!-- in order to keep alive, name must be set on component or globally registered -->
        <keep-alive include="productions,deliveries,inventory,CustomerList,InventoryDefinitionsPage">
          <router-view>
          </router-view>
        </keep-alive>
      </transition>

      <transition name="fade-in" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
        <v-btn
        v-if="showFAB"
        fab
        small
        fixed 
        bottom 
        right 
        hover 
        dark
        color="primary"
        @click="$vuetify.goTo(0)">
          <v-icon dark>keyboard_arrow_up</v-icon>
        </v-btn>
      </transition>
    </v-content>

    <nav-right-extra></nav-right-extra>

    <v-footer height="auto" v-if="false">
      <v-layout justify-center align-center row>
        <svg width="30px" height="30px" version="1.1" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
          <metadata>
            <rdf:RDF>
            <cc:Work rdf:about="">
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>
              <dc:title/>
            </cc:Work>
            </rdf:RDF>
          </metadata>
          <g transform="translate(0,-41)">
            <path fill="transparent" transform="matrix(.26458 0 0 .26458 0 41)" d="m470.8 11.986a472.44 472.44 0 0 0-357.72 180.07 326.47 326.47 0 0 1 149.94 85.664 302.36 302.36 0 0 1 220.76-96.301 302.36 302.36 0 0 1 141.93 35.625 661.42 661.42 0 0 0-154.9-205.06zm77.588 4.1699a642.52 642.52 0 0 1 168.11 275 302.36 302.36 0 0 1 2.4688 2.7891l120.54-120.54a472.44 472.44 0 0 0-291.12-157.24zm-460.52 211.24a472.44 472.44 0 0 0-76.537 256.38 472.44 472.44 0 0 0 78.627 260.41 262.32 262.32 0 0 0 149.45-82.982 302.36 302.36 0 0 1-57.992-177.43 302.36 302.36 0 0 1 56.26-175.26 262.32 262.32 0 0 0-149.8-81.125zm631 446.13a302.36 302.36 0 0 1-8.502 9.5312 642.52 642.52 0 0 1-177.42 270.42 472.44 472.44 0 0 0 306.38-159.49zm-432.59 39.002a326.47 326.47 0 0 1-140.25 100.95 472.44 472.44 0 0 0 337.74 142.75 472.44 472.44 0 0 0 30.883-1.5957 661.42 661.42 0 0 0 134.92-218.38 302.36 302.36 0 0 1-165.8 49.893 302.36 302.36 0 0 1-197.49-73.619z" style="paint-order:stroke fill markers"/>
            <path fill="#1DE9B6" transform="matrix(.26458 0 0 .26458 0 41)" d="m483.78 260.79a222.99 222.99 0 0 0-222.99 222.99 222.99 222.99 0 0 0 222.99 222.99 222.99 222.99 0 0 0 222.99-222.99 222.99 222.99 0 0 0-222.99-222.99zm-27.742 43.791a173.86 173.86 0 0 1 173.86 173.86 173.86 173.86 0 0 1-173.86 173.86 173.86 173.86 0 0 1-173.86-173.86 173.86 173.86 0 0 1 173.86-173.86z" style="paint-order:stroke fill markers"/>
            <path d="m120.66 121.59a46 46 0 0 1 46 46 46 46 0 0 1-46 46 46 46 0 0 1-46-46 46 46 0 0 1 46-46z" :fill="this.$store.state.socketConnection ? 'none' : 'none'" style="paint-order:stroke fill markers"/>
            <path fill="#1DE9B6" transform="matrix(.26458 0 0 .26458 0 41)" d="m508 388.96a122.83 122.83 0 0 0-122.84 122.83 122.83 122.83 0 0 0 122.84 122.84 122.83 122.83 0 0 0 101.4-53.508 109.61 109.61 0 0 1-73.619 28.568 109.61 109.61 0 0 1-109.61-109.61 109.61 109.61 0 0 1 101.88-109.33 122.83 122.83 0 0 0-20.057-1.791z" style="paint-order:stroke fill markers"/>
          </g>
          </svg>
          <span class="footer-icon-color">Corex</span>
      </v-layout>
    </v-footer>

    <!-- DIALOGS -->
    <confirm ref="confirm"></confirm>
    <alert-dialog ref="globalAlertDialog"></alert-dialog>
    <global-loading-dialog ref="globalLoadingDialog"></global-loading-dialog>
    <error-snackbar ref="errorSnackbar"></error-snackbar>

    <v-snackbar
      :timeout="3000"
      vertical
      v-model="showSnackbar"
    >
      Reconnecting
      <v-btn dark text @click.native="showSnackbar = false">Close</v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>

import Vue from 'vue'
import NavMain from '../components/nav/NavMain.vue'
import NavRight from '../components/nav/NavRight.vue'
import NavRightExtra from '../components/nav/NavRightExtra.vue'
import AlertDialog from '../components/dialogs/GlobalAlertDialog.vue'
import ConfirmDialog from '../components/dialogs/GlobalConfirmDialog.vue'
import GlobalLoadingDialog from '../components/dialogs/GlobalLoadingDialog.vue'
import ErrorSnackbar from '../components/errors/GlobalErrorSnackbar.vue'
import WebSocketClient from '../clients/WebSocketClient'
import SearchConsole from '@/components/nav/SearchConsole'
import TracerNav from '@/components/nav/tracer/NavDrawer'
import TimelineNav from '@/components/nav/timeline-right/NavDrawer'
import {mapState} from 'vuex'

export default {
  components: {
    'nav-main': NavMain,
    'nav-right': NavRight,
    'nav-right-extra': NavRightExtra,
    'confirm': ConfirmDialog,
    'error-snackbar': ErrorSnackbar,
    'global-loading-dialog': GlobalLoadingDialog,
    AlertDialog,
    SearchConsole,
    TracerNav,
    TimelineNav
  },
  data: () => ({
    showSnackbar: false,
    showFAB: false,
    transitionName: 'slide-left',
    themes: [
      { title: 'Theme 1', value: 'theme1', dark: false },
      { title: 'Theme 2', value: 'theme2', dark: false },
      { title: 'Theme 1 - Dark', value: 'theme1', dark: true },
      { title: 'Theme 2 - Dark', value: 'theme2', dark: true }
    ],
    randomImageIndex: Math.floor(Math.random() * 1084)
  }),
  computed: {
    ...mapState({
      socketConnection: state => state.socketConnection
    }),
    drawer: {
      get () {
        return this.$store.state.navMain
      },
      set (val) {
        this.$store.commit('openNavMain', val)
      }
    },
    cssProps () {
      return {
        '--c-img-url': this.cssImageUrl,
        '--text-disabled': this.$store.state.themeDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'
      }
    },
    cssImageUrl () {
      return `url('https://picsum.photos/id/${this.randomImageIndex}/1920/1080')`
    }
    /* rightDrawer: {
      get () {
        return this.$store.state.navRight
      },
      set (val) {
        this.$store.commit('openNavRight', val)
      }
    } */
  },
  props: {
    source: String
  },
  watch: {
    /* socketConnection: function (val) {
      if (val) {
        this.showSnackbar = true
      }
    } */
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-rightt' : 'slide-leftt'
    }
  },
  methods: {
    clickThemeImage (url) {
      var split = url.split('/')
      if (split[2] === 'picsum.photos') {
        this.randomImageIndex = split[4]
      }
    },
    clickDeleteThemeImage (url) {
      this.$root.$confirm('Delete this image?', 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$store.commit('deleteBackgroundImage', url)
        }
      })
    },
    saveBackgroundImage () {
      this.$store.commit('saveBackgroundImage', this.cssImageUrl)
    },
    clickMenu () {
      this.$refs.navMain.clickMenu()
    },
    toggleSearchConsole () {
      this.$root.$searchConsole.toggle()
    },
    toggleTracerNav () {
      this.$root.$tracerNav.toggle()
    },
    toggleTimelineNav () {
      this.$root.$timelineNav.toggle()
    },
    onScroll (e) {
      var offsetTop = window.pageYOffset || document.documentElement.scrollTop
      // var offsetBot = document.documentElement.offsetHeight - (document.documentElement.scrollTop + window.innerHeight)
      if (offsetTop > 30) {
        this.showFAB = true
      } else {
        this.showFAB = false
      }
    },
    afterLeave () {
      this.$root.$emit('triggerScroll')
    },
    beforeLeave () {
      // this is triggered once at start of animation
      this.$refs.content.$el.style.overflowX = 'hidden'
    },
    afterEnter () {
      // this is triggered once at end of both animations
      this.$refs.content.$el.style.overflowX = 'auto'
    },
    setTheme (theme) {
      console.log(theme)
      this.$store.commit('setTheme', {
        themeName: theme.value,
        themeDark: theme.dark,
        vuetify: this.$vuetify
        }
      )
    },
    signOut () {
      this.$root.$confirm('Sign out', 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$store.dispatch('auth/logout')
            .then((response) => {
              this.$router.push('/auth/sign-in')
            })
            .catch(() => {
              this.$router.push('/auth/sign-in')
            })
        }
      })
    },
  },
  created () {
  },
  mounted () {
    this.$store.commit('initialize')
    this.$root.$alert = this.$refs.globalAlertDialog.open
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$globalLoadingDialog = this.$refs.globalLoadingDialog.open
    this.$root.$errorSnackbar = this.$refs.errorSnackbar.open
    this.$root.$searchConsole = this.$refs.searchConsole
    this.$root.$tracerNav = this.$refs.tracerNav
    this.$root.$timelineNav = this.$refs.timelineNav
    Vue.prototype.$socket = new WebSocketClient()

    this.setTheme({
      value: this.$store.state.theme,
      dark: this.$store.state.themeDark
    })
  }
}
</script>

<style scoped lang="scss">
.background-transparent {
  background: transparent;
}

.css-settings-dark {
  /* --v-foreground-base: rgba(40,46,60,0.90); */
  --v-input-background: rgba(0,0,0,0.2);
}

.css-settings-light {
  /* --v-foreground-base: rgba(40,46,60,0.90); */
  --v-input-background: #f7fafc;
}

.toolbar-icon-color {
  color: #78909C;
  fill: #78909C;
}

.theme--dark .main-toolbar {
  background-image: linear-gradient(to right, #312644 0%, #1b0e30 100%);
}

.theme--light .main-toolbar {
  background: white;
  /* box-shadow: 2px 2px 2px rgba(0,0,0,0.1)!important; */
  /* background: #f8f9fd; */
}

.theme--dark .main-toolbar::after {
  content: "";
  z-index: -1;
  background: rgba(255,255,255,0.2);
  height:1px;
  width:100%;
  position:absolute;
}

.theme--light .main-toolbar::after {
  content: "";
  z-index: -1;
  background: rgba(0,0,0,0.1);
  height:0.5px;
  width:100%;
  position:absolute;
}

.footer-icon-color {
  fill: #aaa;
  color: #aaa;
}

/* ANIMATIONS */
.slide-left-enter-active, .slide-left-leave-active {
  transition: all .3s ease;
}
.slide-left-enter {
  transform: translateX(80px);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translateX(-80px);
  opacity: 0;
}

.slide-right-enter-active, .slide-right-leave-active {
  transition: all .3s ease;
}
.slide-right-enter {
  transform: translateX(-80px);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translateX(80px);
  opacity: 0;
}
.theme-img-block {
  position: relative;
  background-size: cover;
  background-position: center;
  display: inline-block;
  height: 100px;
  width: 100px;
  border: 1px solid transparent;
  cursor: pointer;
  &:hover {
    border: 1px solid var(--v-color1-base);
  }
}
</style>
